import { Helmet } from "react-helmet-async";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import moment from "moment";
import CustomDatatable from "../../components/CustomDatatable/CustomDatatable";
import FilterBar from "../../components/FilterBar/FilterBar";
import HistoryModal from "../../components/HistoryModal/HistoryModal";
import { Pill } from "../../components/Pill/Pill";

import renderFormatedDate from "../../components/RenderCellsDatatable/renderFormatterDate";
import renderHeader from "../../components/RenderCellsDatatable/renderHeader";

import { useIsFirstRender } from "../../customHooks/useIsFirstRender";

import {
  cleanMessageDocument,
  getListaDocument,
  getDocumentHistoryList,
  getDocumentProducts,
  getDocumentSnippets,
  getDocumentSections,
  changePageSizeDocument,
  loadEmptyDocument,
  getDocumentPreview,
  getDownloadDocument,
  postDocumentDownloadList,
  getDocumentDownloadHistory,
} from "../../store/documents/actions";
import PillModal from "../../components/PillModal/PillModal";
import StatusViewer from "../../components/StatusViewer/StatusViewer";
import useAlert from "../../customHooks/useAlert";
import openPdfFromBase64 from "../../helpers/openPdfFromBase64";
import ActionButtons from "../../components/ActionButtons/ActionButtons";
import { useContextActions } from "../../customHooks/useContextActions";
import ActionList from "../../components/ActionList/ActionList";
import { workflowChangeStatusAlertMessages } from "../../helpers/workflowChangeStatusAlertMessages";
import { cleanMessageWorkflow, putWorkflowChangeStatus } from "../../store/actions";
import downloadBase64File from "../../helpers/downloadBase64File";
import ButtonCustom from "../../components/Buttons/ButtomCustom";
import { DownloadLimitInfo } from "../../components/DownloadLimitInfo/DownloadLimitInfo";
import useLimitedRowSelection from "../../customHooks/useLimitedRowSelection";
import downloadDocuments from "../../helpers/downloadDocuments";
import { MAX_ROW_SELECTION, PAGE_SIZE_OPTIONS } from "../../constants/pagination";

const DocumentsList = ({
  getListDocumentRequest,
  getDocumentHistoryList,
  listaDocument,
  listaDocumentHistory,
  loadingDocument,
  loadingDocumentHistory,
  messageDocument,
  cleanMessageDocument,
  errorLoadingDocumentHistory,
  loadingProducts,
  errorProducts,
  documentProducts,
  documentSections,
  loadingSections,
  errorSections,
  documentSnippets,
  loadingSnippets,
  errorSnippets,
  getDocumentProducts,
  getDocumentSnippets,
  getDocumentSections,
  pageSizeDocument,
  changePageSizeDocument,
  documentPreview,
  errorDocumentPreview,
  loadEmptyDocument,
  getDocumentPreviewRequest,
  cleanMessageWorkflow,
  putWorkflowChangeStatusRequest,
  workflow,
  loadingWorkflow,
  errorMessageWorkflow,
  getDownloadDocumentRequest,
  documentDownload,
  errorDocumentDownload,
  postDocumentDownloadListRequest,
  documentList,
  errorDocumentList,
  getDocumentDownloadHistoryRequest,
  documentDownloadHistory,
  errorDocumentDownloadHistory,
}) => {
  const [objFilter, setObjFilter] = useState({
    status: true,
    createDateStart: null,
    updateDateStart: null,
    createDateEnd: null,
    updateDateEnd: null,
    regions: [],
    business: [],
    products: [],
    sections: [],
    snippets: [],
    createUsers: [],
    updateUsers: [],
    statusWorkflow: [],
    type: [],
    searchText: null,
  });
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: pageSizeDocument,
    page: 0,
  });
  
  const [currentPageHistory, setCurrentPageHistory] = useState(1);
  const [idCurrentDocumentHistory, setIdCurrentDocumentHistory] = useState(null);
  const pageSizeHistory = 10;
  const totalPagesHistory = Math.ceil(
    (listaDocumentHistory?.totalRecords || 0) / pageSizeHistory
  );
  const handlePageChangeHistory = (page) => {
    if (!idCurrentDocumentHistory) return;
    if (page < 1 || page > totalPagesHistory) return;
    setCurrentPageHistory(page);

    getDocumentHistoryList({
      documentId: idCurrentDocumentHistory,
      page,
    });
  };

  const { errorAlert, successAlert, confirmWorkflowChangeStatus } = useAlert();
  const successMessageAlertRef = useRef("");
  const isFirstRender = useIsFirstRender();
  const navigate = useNavigate();
  const alertModal = withReactContent(Swal);
  const actions = useContextActions({
    context: "document",
    screen: "list",
  });
  
  const { selectedRows, handleRowSelectionChange, selectedCount, clearSelection } = useLimitedRowSelection(MAX_ROW_SELECTION);
  
  const handlePageChange = (model) => {
    const { page, pageSize } = model;
    setPaginationModel({
      pageSize: pageSize,
      page: page,
    });
    changePageSizeDocument(pageSize);

    getListDocumentRequest({
      pageNumber: page + 1,
      pageSize: pageSize,
      status: objFilter.status,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      regions: objFilter.regions,
      business: objFilter.business,
      products: objFilter.products,
      sections: objFilter.sections,
      snippets: objFilter.snippets,
      createUsers: objFilter.createUsers,
      updateUsers: objFilter.updateUsers,
      statusWorkflow: objFilter.statusWorkflow,
      type: objFilter.type,
      searchText: objFilter.searchText,
    });
  };
  const handleSortChange = (model) => {
    console.log(model);
  };
  const handleRowClick = (params) => {
    navigate(`/document?id=${params.id}`);
  };
  const fetchDocumentHistory = (documentId) => {
    getDocumentHistoryList({ documentId, page: 1 });
  };
  const fetchQuantityProducts = (documentId) => {
    getDocumentProducts({ documentId });
  };
  const fetchQuantitySections = (documentId) => {
    getDocumentSections({ documentId });
  };
  const fetchQuantitySnippets = (documentId) => {
    getDocumentSnippets({ documentId });
  };
  const refreshListData = () => {
    getListDocumentRequest({
      pageNumber: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      status: objFilter.status,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      regions: objFilter.regions,
      business: objFilter.business,
      products: objFilter.products,
      sections: objFilter.sections,
      snippets: objFilter.snippets,
      createUsers: objFilter.createUsers,
      updateUsers: objFilter.updateUsers,
      statusWorkflow: objFilter.statusWorkflow,
      type: objFilter.type,
      searchText: objFilter.searchText,
    });
  };
  const handleDownladDocumentsList = () => {
    const normalizedFilter = {
      ...objFilter,
      createDateStart: objFilter.createDateStart || null,
      createDateEnd: objFilter.createDateEnd || null,
      updateDateStart: objFilter.updateDateStart || null,
      updateDateEnd: objFilter.updateDateEnd || null,
    }

    postDocumentDownloadListRequest({ objFilter: normalizedFilter });
  };
  
  const handleDocumentPreview = (e, documentId) => {
    e.stopPropagation();
    getDocumentPreviewRequest({ documentId });
  };
  const handleDocumentSendToReview = (e, documentId) => {
    e.stopPropagation();
    confirmWorkflowChangeStatus({
      html: workflowChangeStatusAlertMessages["Draft"].Question,
    }).then((result) => {
      if (!result.isConfirmed) return;

      successMessageAlertRef.current =
        workflowChangeStatusAlertMessages["Draft"].Success;
      putWorkflowChangeStatusRequest({
        idDocument: documentId,
        type: "Review",
      });
    });
  };
  const handleDocumentReview = (e, documentId) => {
    e.stopPropagation();
    navigate(`/document?id=${documentId}`);
  };
  const handleDocumentPublish = (e, documentId) => {
    e.stopPropagation();
    confirmWorkflowChangeStatus({
      html: workflowChangeStatusAlertMessages["Publish"].Question,
    }).then((result) => {
      if (!result.isConfirmed) return;

      successMessageAlertRef.current =
        workflowChangeStatusAlertMessages["Publish"].Success;
      putWorkflowChangeStatusRequest({
        idDocument: documentId,
        type: "Publish",
      });
    });
  };
  const handleDocumentDownloadPDF = (e, documentId) => {
    e.stopPropagation();
    getDownloadDocumentRequest({
      documentId: documentId,
      type: "pdf",
    });
  };
  const handleDocumentDownloadDOCX = (e, documentId) => {
    e.stopPropagation();
    getDownloadDocumentRequest({
      documentId: documentId,
      type: "docx",
    });
  };

  const handleDocumentDownloadHistoryDOCX = (documentId, type) => {
    getDocumentDownloadHistoryRequest({
      documentId: documentId,
      type: type,
    });
  };
  const handleDocumentDownloadHistoryPDF = (documentId, type) => {
    getDocumentDownloadHistoryRequest({
      documentId: documentId,
      type: type,
    });
  };
  const handleDetailDocumentHistory = (item) => {
    window.open(`/document?idHistory=${item.idHistory}`, "_blank");
  };
  const handleDownloadDocuments = async () => {
    try {
      setLoadingDownload(true);
      const documentIds = Array.from(selectedRows.ids);
      if (documentIds.length === 0) return;
      
      const fileName = `Documents_${moment().format("YYYYMMDD")}.zip`;
      const success = await downloadDocuments(documentIds, fileName);
      if (success) {
        successAlert("Documents .zip downloaded successfully");
      }
    } catch (err) {
      errorAlert(err.message);
    } finally {
      setLoadingDownload(false);
    }
  };
  
  const columns = [
    {
      field: "createDate",
      headerName: "Creation date",
      flex: 1,
      sortable: false,
      renderCell: renderFormatedDate,
      renderHeader: renderHeader,
    },
    {
      field: "updateDate",
      headerName: "Update date",
      flex: 1,
      sortable: false,
      renderCell: renderFormatedDate,
      renderHeader: renderHeader,
    },
    {
      field: "regionName",
      headerName: "Region",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "businessName",
      headerName: "Business",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "title",
      headerName: "Document Title",
      flex: 2,
      sortable: false,
      renderHeader: renderHeader,
    },
    {
      field: "totalProducts",
      headerName: "Products",
      // flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <PillModal
          trigger={
            <Pill
              value={params.row.totalProducts}
              svg={
                <svg
                  width={18}
                  height={18}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 640"
                >
                  <path
                    d="M272 32L368 32C385.7 32 400 46.3 400 64C400 81.7 385.7 96 368 96L272 96C254.3 96 240 81.7 240 64C240 46.3 254.3 32 272 32zM176 208C176 172.7 204.7 144 240 144L400 144C435.3 144 464 172.7 464 208C464 232.1 450.7 253.1 431 264C450.7 274.9 464 295.9 464 320C464 344.1 450.7 365.1 431 376C450.7 386.9 464 407.9 464 432C464 456.1 450.7 477.1 431 488C450.7 498.9 464 519.9 464 544C464 579.3 435.3 608 400 608L240 608C204.7 608 176 579.3 176 544C176 519.9 189.3 498.9 209 488C189.3 477.1 176 456.1 176 432C176 407.9 189.3 386.9 209 376C189.3 365.1 176 344.1 176 320C176 295.9 189.3 274.9 209 264C189.3 253.1 176 232.1 176 208z"
                    fill="white"
                  />
                </svg>
              }
            />
          }
          fetchQuantity={() => {
            fetchQuantityProducts(params.row.id);
          }}
          loading={loadingProducts}
          data={documentProducts}
          error={errorProducts}
          view="document" //View que estamos singular
          variant="Products" //Variante no plural
        />
      ),
    },
    {
      field: "totalSections",
      headerName: "Sections",
      // flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <PillModal
          trigger={
            <Pill
              value={params.row.totalSections}
              svg={
                <svg
                  width={18}
                  height={18}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 640"
                >
                  <path
                    d="M465.4 192L431.1 144L209 144L174.7 192L465.4 192zM96 212.5C96 199.2 100.2 186.2 107.9 175.3L156.9 106.8C168.9 90 188.3 80 208.9 80L431 80C451.7 80 471.1 90 483.1 106.8L532 175.3C539.8 186.2 543.9 199.2 543.9 212.5L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 212.5z"
                    fill="white"
                  />
                </svg>
              }
            />
          }
          fetchQuantity={() => {
            fetchQuantitySections(params.row.id);
          }}
          loading={loadingSections}
          data={documentSections}
          error={errorSections}
          view="document" //View que estamos singular
          variant="Sections" //Variante no plural
        />
      ),
    },
    {
      field: "totalSnippets",
      headerName: "Snippets",
      // flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <PillModal
          trigger={
            <Pill
              value={params.row.totalSnippets}
              svg={
                <svg
                  width={18}
                  height={18}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 640"
                >
                  <path
                    fill="white"
                    d="M296.5 69.2C311.4 62.3 328.6 62.3 343.5 69.2L562.1 170.2C570.6 174.1 576 182.6 576 192C576 201.4 570.6 209.9 562.1 213.8L343.5 314.8C328.6 321.7 311.4 321.7 296.5 314.8L77.9 213.8C69.4 209.8 64 201.3 64 192C64 182.7 69.4 174.1 77.9 170.2L296.5 69.2zM112.1 282.4L276.4 358.3C304.1 371.1 336 371.1 363.7 358.3L528 282.4L562.1 298.2C570.6 302.1 576 310.6 576 320C576 329.4 570.6 337.9 562.1 341.8L343.5 442.8C328.6 449.7 311.4 449.7 296.5 442.8L77.9 341.8C69.4 337.8 64 329.3 64 320C64 310.7 69.4 302.1 77.9 298.2L112 282.4zM77.9 426.2L112 410.4L276.3 486.3C304 499.1 335.9 499.1 363.6 486.3L527.9 410.4L562 426.2C570.5 430.1 575.9 438.6 575.9 448C575.9 457.4 570.5 465.9 562 469.8L343.4 570.8C328.5 577.7 311.3 577.7 296.4 570.8L77.9 469.8C69.4 465.8 64 457.3 64 448C64 438.7 69.4 430.1 77.9 426.2z"
                  />
                </svg>
              }
            />
          }
          fetchQuantity={() => {
            fetchQuantitySnippets(params.row.id);
          }}
          loading={loadingSnippets}
          data={documentSnippets}
          error={errorSnippets}
          view="document" //View que estamos singular
          variant="Snippets" //Variante no plural
        />
      ),
    },
    {
      field: "status",
      headerName: "Status",
      // flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => <StatusViewer status={params.value} />,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <ActionList
          id={params.row.id}
          status={params.row.status}
          onPreview={handleDocumentPreview}
          onSendToReview={handleDocumentSendToReview}
          onReview={handleDocumentReview}
          onPublish={handleDocumentPublish}
          onDownloadPDF={(e) => handleDocumentDownloadPDF(e, params.row.id)}
          onDownloadDOCX={(e) => handleDocumentDownloadDOCX(e, params.row.id)}
          actions={actions}
        />
      ),
    },
    {
      field: "id",
      headerName: "History",
      // flex: 1,
      sortable: false,
      renderHeader: renderHeader,
      renderCell: (params) => (
        <HistoryModal
          variant="documents"
          trigger={
            <Button color="" style={{ width: 50, height: 50 }}>
              <i className="fas fa-history"></i>
            </Button>
          }
          fetchHistory={() => {
            fetchDocumentHistory(params.value)
            setCurrentPageHistory(1);
            setIdCurrentDocumentHistory(params.value);
          }}
          loading={loadingDocumentHistory}
          data={listaDocumentHistory?.records}
          onDetail={handleDetailDocumentHistory}
          errorLoadingHistory={errorLoadingDocumentHistory}
          downloadHistoryPdf={(item) => handleDocumentDownloadHistoryPDF(item.idHistory, "pdf")}
          downloadHistoryDocx={(item) => handleDocumentDownloadHistoryDOCX(item.idHistory, "docx")}

          handlePageChange={handlePageChangeHistory}
          totalPages={totalPagesHistory}
          currentPage={currentPageHistory}

          columns={[
            {
              key: "updateDate",
              render: (item) =>
                moment(item.updateDate ?? item.createDate).format(
                  "DD MMM/YY hh:mm A",
                ),
            },
            {
              key: "status",
              render: (item) => {
                return <StatusViewer status={item.status} />;
              },
            },
            {
              key: "updateUser",
              render: (item) => item.updateUser ?? item.createUser,
            },
          ]}
        />
      ),
    },
  ];

  useEffect(() => {
    if (messageDocument) {
      alertModal
        .fire({
          title: messageDocument ?? "Something wrong, try again later.",
          icon: "error",
          showConfirmButton: false,
          showCloseButton: true,
        })
        .then(() => cleanMessageDocument());
    }
    // eslint-disable-next-line
  }, [messageDocument]);
  useEffect(() => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));

    getListDocumentRequest({
      pageNumber: 1,
      pageSize: paginationModel.pageSize,
      status: objFilter.status,
      createDateStart: objFilter.createDateStart,
      updateDateStart: objFilter.updateDateStart,
      createDateEnd: objFilter.createDateEnd,
      updateDateEnd: objFilter.updateDateEnd,
      regions: objFilter.regions,
      business: objFilter.business,
      products: objFilter.products,
      sections: objFilter.sections,
      snippets: objFilter.snippets,
      createUsers: objFilter.createUsers,
      updateUsers: objFilter.updateUsers,
      statusWorkflow: objFilter.statusWorkflow,
      type: objFilter.type,
      searchText: objFilter.searchText,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objFilter]);
  useEffect(() => {
    if (documentPreview) {
      openPdfFromBase64(documentPreview.base64);
      return;
    }

    return () => {
      loadEmptyDocument();
    };
    // eslint-disable-next-line
  }, [documentPreview]);
  useEffect(() => {
    if (errorDocumentPreview) {
      errorAlert(
        errorDocumentPreview ? errorDocumentPreview : "Try again later!",
        {
          didClose: () => {
            cleanMessageDocument();
          },
        },
      );
    }
    // eslint-disable-next-line
  }, [errorDocumentPreview]);
  useEffect(() => {
    if (workflow !== null) {
      if (workflow) {
        successAlert(
          successMessageAlertRef.current,
          {
            didClose: () => {
              refreshListData()
            }
          }
        )
      }
    } else {
      if (errorMessageWorkflow) {
        errorAlert(
          errorMessageWorkflow ? errorMessageWorkflow : "Try again later!",
        ).then((result) => {
          if (result.dismiss) {
            cleanMessageWorkflow();
          }
        });
      }
    }

    return () => {
      cleanMessageWorkflow();
    }
    // eslint-disable-next-line
  }, [workflow, errorMessageWorkflow]);
  useEffect(() => {
    async function handleDownload() {
      if (documentDownload) {
        const { base64, fileName, extension } = documentDownload;
        const success = await downloadBase64File(base64, fileName, extension);

        if (success) {
          successAlert("Document downloaded successfully", {
            didClose: () => {
              cleanMessageDocument();
            },
          });
        }

        return;
      }

      if (errorDocumentDownload) {
        errorAlert(errorDocumentDownload || "Try again later!", {
          didClose: () => {
            cleanMessageDocument();
          },
        });
      }
    }

    handleDownload();
  
      // eslint-disable-next-line
  }, [documentDownload, errorDocumentDownload]);
  useEffect(() => {
    async function handleDownload() {
      if (documentList) {
        const base64 = documentList;
        const fileName = `Documents_${moment().format("YYYYMMDD")}.xlsx`;

        const success = await downloadBase64File(base64, fileName, "xlsx");

        if (success) {
          successAlert("Documents list downloaded successfully", {
            didClose: () => {
              cleanMessageDocument();
            },
          });
        }

        return;
      }

      if (errorDocumentList) {
        errorAlert(errorDocumentList || "Try again later!", {
          didClose: () => {
            cleanMessageDocument();
          },
        });
      }
    }

    handleDownload();

    return () => {
      cleanMessageDocument();
    }
  // eslint-disable-next-line
  }, [documentList, errorDocumentList]);
  useEffect(() => {
    async function handleDownload() {
      if (documentDownloadHistory) {
        const { base64, fileName, extension } = documentDownloadHistory;
        const success = await downloadBase64File(base64, fileName, extension);

        if (success) {
          successAlert("Document downloaded successfully", {
            didClose: () => {
              cleanMessageDocument();
            },
          });
        }

        return;
      }

      if (errorDocumentDownloadHistory) {
        errorAlert(errorDocumentDownloadHistory || "Try again later!", {
          didClose: () => {
            cleanMessageDocument();
          },
        });
      }
    }

    handleDownload();
    // eslint-disable-next-line
  }, [documentDownloadHistory, errorDocumentDownloadHistory]);
  
  
  
  return (
    <div className="page-content">
      <Helmet>
        <title>Documents</title>
      </Helmet>

      <Container fluid>
        <Row>
          <Col md={12}>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between my-2">
                  <h2>DOCUMENTS</h2>
                  <ActionButtons
                    actions={actions}
                    context="document"
                    handlers={{
                      create: () => navigate("/document"),
                    }}
                  />
                </div>

                <Row>
                  <Col md={12}>
                    <FilterBar
                      setObjFilter={setObjFilter}
                      placeholderSearch="Search by document title"
                      isFirstRender={isFirstRender}
                      variant="documents"
                    />
                  </Col>
                </Row>

                <Row className="my-2">
                  {loadingDocument || loadingWorkflow || loadingDownload ? (
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ height: 400, width: "100%" }}
                    >
                      <Spinner
                        color="primary"
                        style={{ height: "5rem", width: "5rem" }}
                      />
                    </div>
                  ) : (
                    <>
                      <div className="d-flex align-center justify-content-end gap-2 mb-3">
                        <ButtonCustom 
                          type="export"
                          onClick={handleDownladDocumentsList}
                          disabled={listaDocument.records.length === 0}
                        />
                        <ButtonCustom 
                          type="download_OP2"
                          onClick={handleDownloadDocuments}
                          disabled={selectedCount === 0 || selectedCount > MAX_ROW_SELECTION}
                        />
                        {selectedCount > 0 && (
                          <ButtonCustom
                            type="clear"
                            onClick={clearSelection}
                          >
                          </ButtonCustom>
                        )}
                      </div>
                      
                      <DownloadLimitInfo selectedCount={selectedCount} max={MAX_ROW_SELECTION} />
                      
                      <CustomDatatable
                        columns={columns}
                        rows={listaDocument.records}
                        pagination
                        paginationMode="server"
                        rowCount={listaDocument?.totalRecords ?? 0}
                        paginationModel={paginationModel}
                        onPaginationModelChange={handlePageChange}
                        onSortModelChange={handleSortChange}
                        onRowClick={handleRowClick}
                        pageSizeOptions={PAGE_SIZE_OPTIONS}
                        disableColumnFilter
                        disableColumnMenu
                        checkboxSelection={true}
                        rowSelectionModel={selectedRows}
                        onRowSelectionModelChange={(model) =>
                          handleRowSelectionChange(model, listaDocument.records)
                        }
                        isRowSelectableForStatus={true}
                      />
                    </>
                  )}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const mapStateToProps = ({
  DocumentReducer: {
    listaDocument,
    listaDocumentHistory,
    loadingDocument,
    loadingDocumentHistory,
    messageDocument,
    errorLoadingDocumentHistory,
    loadingProducts,
    errorProducts,
    documentProducts,
    documentSections,
    loadingSections,
    errorSections,
    documentSnippets,
    loadingSnippets,
    errorSnippets,
    pageSizeDocument,
    documentPreview,
    errorDocumentPreview,
    documentDownload,
    errorDocumentDownload,
    documentList,
    errorDocumentList,
    documentDownloadHistory,
    errorDocumentDownloadHistory,
  },
  WorkflowReducer: { workflow, loadingWorkflow, errorMessageWorkflow },
}) => ({
  listaDocument,
  listaDocumentHistory,
  loadingDocument,
  loadingDocumentHistory,
  messageDocument,
  errorLoadingDocumentHistory,

  loadingProducts,
  errorProducts,
  documentProducts,

  documentSections,
  loadingSections,
  errorSections,

  documentSnippets,
  loadingSnippets,
  errorSnippets,
  pageSizeDocument,
  documentPreview,
  errorDocumentPreview,

  workflow,
  loadingWorkflow,
  errorMessageWorkflow,

  documentDownload,
  errorDocumentDownload,

  documentList,
  errorDocumentList,

  documentDownloadHistory,
  errorDocumentDownloadHistory,
});

const mapDispatchToProps = {
  getListDocumentRequest: getListaDocument.request,
  getDocumentHistoryList: getDocumentHistoryList.request,
  cleanMessageDocument,
  loadEmptyDocument,
  getDocumentProducts: getDocumentProducts.request,
  getDocumentSnippets: getDocumentSnippets.request,
  getDocumentSections: getDocumentSections.request,
  getDocumentPreviewRequest: getDocumentPreview.request,
  getDownloadDocumentRequest: getDownloadDocument.request,
  postDocumentDownloadListRequest: postDocumentDownloadList.request,
  changePageSizeDocument,
  cleanMessageWorkflow,
  putWorkflowChangeStatusRequest: putWorkflowChangeStatus.request,
  getDocumentDownloadHistoryRequest: getDocumentDownloadHistory.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsList);
